import { useSelector } from "react-redux";
import { selectOrganizationList } from "../reducers/organizationSlice";
import { selectLoggedInUser } from "../reducers/appSlice";
import { useMemo } from "react";

export const usePermissions = () => {
  const organizations = useSelector(selectOrganizationList);
  const currentUser = useSelector(selectLoggedInUser);

  const userHasAccess = useMemo(() => {
    const tmsOrgs = organizations?.filter?.((org) => org.tms);
    return currentUser.tms || tmsOrgs?.length > 0;
  }, [organizations, currentUser]);

  return {userHasAccess};
};
